import React, { useState } from 'react';

const ResetRequestForm = ({ loading, error, done, onSubmit, onBackToSignIn }) => {
  const [username, setUsername] = useState('');
  const [localError, setLocalError] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = username.trim();
    if (!trimmed) {
      setLocalError('Enter your username.');
      return;
    }
    setLocalError(null);
    onSubmit(trimmed);
  };

  if (done) {
    return (
      <>
        <div className="login-brand">TD</div>
        <h1>Reset your password</h1>
        <div className="login-notice" role="status">
          If that account exists, an administrator has been notified to reset it.
        </div>
        <button className="bh-btn-primary login-submit" type="button" onClick={onBackToSignIn}>
          Back to sign in
        </button>
      </>
    );
  }

  return (
    <>
      <div className="login-brand">TD</div>
      <h1>Reset your password</h1>
      <p className="login-subtitle">
        Enter your username and an administrator will set you up with a new password.
      </p>
      <form onSubmit={handleSubmit} noValidate>
        <label htmlFor="username">Username</label>
        <input
          className="bh-input"
          type="text"
          id="username"
          name="username"
          autoComplete="username"
          placeholder="Your username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        {(localError || error) && (
          <div className="login-error" role="alert">{localError || error}</div>
        )}
        <button className="bh-btn-primary login-submit" type="submit" disabled={loading}>
          {loading ? 'Sending…' : 'Send reset request'}
        </button>
      </form>
      <div className="login-toggle-note">
        Remembered it?{' '}
        <button type="button" className="login-link-btn" onClick={onBackToSignIn}>
          Back to sign in
        </button>
      </div>
    </>
  );
};

export default ResetRequestForm;
